export const jsonDump = (data: any) => {
  return JSON.stringify(data, null, 2)
}
